import {IntermediatePart} from "../../intermediatePart";

export default class Baseboard extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'baseboard';
    this.partName = 'Baseboard';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Baseboard());
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.Baseboard;
    }
  }
}